import { createFileRoute } from '@tanstack/react-router';

import AiWizardTab from '@/pages/administration/tabs/ai-wizard';

export const Route = createFileRoute('/administration/ai-wizard/')({
  component: AiWizardTab,
});
